import React, { JSX } from 'react'
import { Navigate } from 'react-router-dom'
import { isTokenValid } from '../lib/auth'


const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  return isTokenValid() ? children : <Navigate to="/login" />
}

export default PrivateRoute